export function orgaosInRequest(params = {}) {
  return {
    type: '@orgao/ORGAOS_IN_REQUEST',
    payload: { params },
  };
}

export function findOrgao(idorgao) {
  return {
    type: '@orgao/FIND_ORGAO',
    payload: { idorgao },
  };
}

export function failedRequest() {
  return {
    type: '@orgao/FAILED_REQUEST',
  };
}

export function deleteOrgao(idorgao, params) {
  return {
    type: '@orgao/DELETE_ORGAO',
    payload: { idorgao, params },
  };
}

export function updateOrgao(orgao, params) {
  return {
    type: '@orgao/UPDATE_ORGAO',
    payload: { orgao, params },
  };
}

export function storeOrgao(orgao, params) {
  return {
    type: '@orgao/STORE_ORGAO',
    payload: { orgao, params },
  };
}

export function successInRequest(
  orgaos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@orgao/SUCCESS_IN_REQUEST',
    payload: { orgaos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(orgao) {
  return {
    type: '@orgao/SUCCESS_REQUEST',
    payload: { orgao },
  };
}

export function successRemove(params) {
  return {
    type: '@orgao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@orgao/RECORD_FILTERING',
    payload: { params },
  };
}

export function changeItemFind(data) {
  return {
    type: '@orgao/CHANGE_ITEM_FIND',
    payload: { data },
  };
}
